import { Link, Text, VStack } from '@direct-frontend/components';
import type { LoyaltyRegistrationStep } from '@/shared/api/loyalty';
import { BonusBadge } from '@/shared/components/BonusBadge';
import { DrawerHeader } from '@/shared/components/Drawer';

interface LoyaltyRegistrationPromoProps {
    step: LoyaltyRegistrationStep;
    loyaltyProgramUrl: string;
    potentialBonuses: number;
    welcomeBonuses: number;
}

export const LoyaltyRegistrationPromo = (props: LoyaltyRegistrationPromoProps) => {
    const { step, loyaltyProgramUrl, potentialBonuses, welcomeBonuses } = props;

    const hasWelcomeBonuses = welcomeBonuses > 0;
    const hasPotentialBonuses = potentialBonuses > 0;
    const hasBonuses = hasWelcomeBonuses || hasPotentialBonuses;

    return (
        <>
            <VStack gap="16">
                <DrawerHeader
                    title={step === 'last-step' ? 'Подтвердите участие в программе лояльности' : 'Программа лояльности'}
                />

                <Text size="mc">
                    Подключитесь к{' '}
                    <Link href={loyaltyProgramUrl} target="_blank">
                        программе лояльности
                    </Link>
                    , чтобы получать бонусы за покупки и тратить их на заказы
                </Text>
            </VStack>

            {hasBonuses && (
                <VStack gap="16">
                    {hasWelcomeBonuses && (
                        <BonusBadge description={`Приветственный бонус за\u00a0регистрацию`} icon="present">
                            +{welcomeBonuses}
                        </BonusBadge>
                    )}

                    {hasPotentialBonuses && (
                        <BonusBadge description={`За покупку товаров в\u00a0корзине`}>+{potentialBonuses}</BonusBadge>
                    )}
                </VStack>
            )}
        </>
    );
};
